import { AriaAttributes, FC, ReactElement, useRef } from 'react';

import Basket from '../Basket/Basket';
import { EcomOnly } from '../EcomOnly/EcomOnly';
import { JabraFocusGroup } from '../JabraFocus';
import { DesktopTopMenu, MobileTopMenu, useHeaderConfig } from '../MegaMenu';
import { SubmenuComponent } from './SubmenuComponent';

export interface AppHeaderProps {
  condensedMenu?: ReactElement;
}

export const AppHeader: FC<AppHeaderProps & AriaAttributes> = ({ condensedMenu, ...props }) => {
  const { isNavigationTransparent, showNavigation } = useHeaderConfig();
  const headerRef = useRef<HTMLHeadingElement>(null);

  return (
    <header ref={headerRef} className="top-menu relative z-30 flex flex-col bg-white" {...props}>
      <JabraFocusGroup orientation="both" id="header" className="z-30">
        <div className="flex content-center justify-between">
          <MobileTopMenu
            isNavigationTransparent={isNavigationTransparent?.value}
            showNavigation={showNavigation?.value}
          />
          <DesktopTopMenu
            isNavigationTransparent={isNavigationTransparent?.value}
            showNavigation={showNavigation?.value}
          />

          <EcomOnly>
            <Basket />
          </EcomOnly>
        </div>
        <SubmenuComponent headerRef={headerRef} />
      </JabraFocusGroup>
      {condensedMenu}
    </header>
  );
};
